import React from 'react'
import DefaultForm from '../../../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import { UpdateStartDateFields, UpdateStartDateDone } from './fields'

const actionValue = 'update_start_date'
const actionLabel = 'Update Enrolment start date'

const available = record => hasAvailableAction(record, actionValue)
const defaultStartDate = ({ gov_record = {} }) => gov_record.arrangementStartDate

const formEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/ccs-enrolments/${gov_id}/update-start-date`

const updateEnrolmentForm = ({ record }) => ({ handleSuccess }) => (
  <DefaultForm
    url={formEndPoint(record)}
    name={actionValue}
    label={actionLabel}
    formComponent={UpdateStartDateFields}
    formOptions={{
      defaultValues: {
        startDate: defaultStartDate(record),
      },
    }}
    handleSuccess={() =>
      handleSuccess(
        {
          [actionValue]: <UpdateStartDateDone />,
        },
        actionValue
      )
    }
  />
)

export const updateEnrolmentStartDate = ({ record, refresh_enrolments }) =>
  available(record)
    ? {
      label: actionLabel,
      value: actionValue,
      actionForm: updateEnrolmentForm({ record }),
      onComplete: refresh_enrolments,
    }
    : null



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-start-date/index.js